/**
 * True when an RQB tree carries at least one authored leaf *anywhere* in it.
 *
 * Stricter than `isEmptyConditionsTree`, which only answers whether the root group's own
 * `rules` is empty. A single "+ Group" click with nothing in it produces
 * `{combinator: 'and', rules: [{combinator: 'and', rules: []}]}` — a non-empty root holding no
 * predicate at all. The compiler emits the root combinator's identity for such a tree (`true`
 * for AND), which a rule set that requires conditions refuses: for a policy category, whose
 * condition is required, a category matching every policy.
 *
 * A bare root leaf counts as authored, matching `isEmptyConditionsTree`'s treatment of the
 * same shape: it travels to the BE and is rejected there out loud rather than here.
 */

import type { RuleGroupType, RuleType } from 'react-querybuilder';

const isRuleGroup = (node: RuleGroupType | RuleType): node is RuleGroupType =>
  'rules' in node && Array.isArray(node.rules);

export const hasAuthoredCondition = (node: RuleGroupType | RuleType | null | undefined): boolean => {
  if (!node) {
    return false;
  }
  if (!isRuleGroup(node)) {
    return true;
  }
  return node.rules.some((child) => hasAuthoredCondition(child));
};
